import { PaginationButtonsEnum } from './interfaces.js';

function generateUiItemList({ range, activePage }) {
    const generatedRange = [...range];
    const lastItem = generatedRange[generatedRange.length - 1];
    if (generatedRange.length <= 5) {
        return generatedRange;
    }
    if (activePage > 3 && lastItem - 1 === activePage + 1) {
        generatedRange.splice(1, activePage - 2, PaginationButtonsEnum.ELLIPSIS);
        return generatedRange;
    }
    if (activePage <= 2 && lastItem - 1 !== activePage + 1) {
        generatedRange.splice(2, generatedRange.length - 3, PaginationButtonsEnum.ELLIPSIS);
        return generatedRange;
    }
    if (activePage <= 3 && lastItem - 1 !== activePage + 1) {
        generatedRange.splice(3, generatedRange.length - 4, PaginationButtonsEnum.ELLIPSIS);
        return generatedRange;
    }
    if (activePage > 3 && activePage >= generatedRange.length - 1) {
        generatedRange.splice(1, generatedRange.length - 3, PaginationButtonsEnum.ELLIPSIS);
        return generatedRange;
    }
    if (activePage > 3 && activePage < generatedRange.length - 1) {
        generatedRange.splice(1, activePage - 2, PaginationButtonsEnum.ELLIPSIS);
        generatedRange.splice(3, generatedRange.length - 4, PaginationButtonsEnum.ELLIPSIS);
        return generatedRange;
    }
    return generatedRange;
}
/**
 * Given a number of available pages and the current active page
 * returns a list with the pattern defined by design.
 * @example numberOfPages = 20; activePage = 10;
 * returns: ['previous', 1, '...', 10, '...', 20, 'next'];
 */
function usePagination({ numberOfPages, activePage }) {
    const range = Array.from({ length: numberOfPages || 0 }, (_, i) => i + 1);
    const uiItemList = generateUiItemList({ range, activePage });
    uiItemList.unshift(PaginationButtonsEnum.PREVIOUS);
    uiItemList.push(PaginationButtonsEnum.NEXT);
    return { uiItemList, itemList: range };
}

export { usePagination };
